<template>
  <div>
    <!--  <div>query= {{ $route.query }}</div> -->
    <!--  <div>etape= {{ etape }}</div>
    <div>activite = {{ activite }}</div> -->

    <v-card>
      <v-system-bar dark color="grey darken-1" height="50">
        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.push('/organisation/bailleurs')"
        >
          <v-icon>mdi-arrow-left-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        Statistiques pour l'activité {{ activite.ll_parcours }}
        <v-spacer></v-spacer>

        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.push('/organisation/bailleurs')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-system-bar>
      <div class="ma-4 pa-4">
        <div class="h4">
          {{ activite.abbr_bailleur }} - {{ activite.ll_bailleur }}
        </div>
        <div class="h4">
          {{ activite.ll_programme }} - {{ activite.ll_theme }}
        </div>
        <div class="h4">{{ activite.ll_parcours }} - {{ etape.ll_etape }}</div>
        <!--  <div>{{ $route.query.ll_details_etapes }}</div> -->
      </div>
      <v-card-text>
     
       <div>  {{ $route.query}}</div>
       <div>  {{ $route.query.etape_id_etape}}</div>

      </v-card-text>
      <v-card-actions>
        <v-container fluid>
          <v-row align="center">
            <v-col class="my-0 py-0">
              <v-btn
                class="blue mx-4"
                dark
                :loading="loadingMembre"
                @click="getFichesCorrespondantes()"
              >
                Afficher les détails</v-btn
              >
            </v-col>
        <!--     <v-col class="my-0 py-0">
              <v-btn
                class="blue mx-4"
                dark
                :loading="loadingMembre"
                @click="getEtapesEffectives()"
              >
                Afficher les Totaux</v-btn
              >
            </v-col> -->
          </v-row>
        </v-container>
      </v-card-actions>
      <v-card-text>
        <div>Nombre: {{ fiches.length }}</div>
        <div v-if="$route.query.type_champ == 1">
          {{ $route.query.ll_details_etapes }} :
          <strong>{{ calcul.toLocaleString() }}</strong>
        </div>

        <vue-excel-xlsx
          class="mt-4"
          v-if="fiches.length > 0"
          :data="fiches"
          :columns="headers"
          :filename="'fiches' + Date.now()"
          :sheetname="'fiches'"
        >
          <v-btn class="green" dark>
            <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
            Télécharger les
            {{ fiches.length }} résultats</v-btn
          >
        </vue-excel-xlsx>

        <v-data-table
          dense
          :headers="headers"
          :items="fiches"
          locale="fr"
          :items-per-page="50"
        >
          <template v-slot:item.sexe="{ item }">
            {{ getSexe(item.sexe) }}
          </template>
          <template v-slot:item.date_fiche="{ item }">
            {{ epochToTimeStamp(item.date_fiche) }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loadingMembre: false,
      etape: "",
      activite: "",
      fiches: [],
      etapesEffectives: [],
      headers: [
        {
          text: "ID FICHE",
          value: "id",
          label: "ID FICHE",
          field: "id",
        },
        {
          text: "Id Membre",
          value: "membres_id_membre",
          label: "Id membre",
          field: "membres_id_membre",
        },
        {
          text: "Nom",
          label: "Nom",
          value: "nom",
          field: "nom",
        },
        {
          text: "Année de naissance",
          label: "Année de naissance",
          value: "annee_naissance",
          field: "annee_naissance",
        },
        {
          text: "Sexe",
          value: "sexe",
          label: "Sexe",
          field: "sexe",
          dataFormat: this.getSexe,
        },
        {
          text: "Groupe",
          label: "Groupe",
          value: "nom_groupe",
          field: "nom_groupe",
        },
        {
          text: this.$route.query.ll_details_etapes,
          label: this.$route.query.ll_details_etapes,
          value: "valInt",
          field: "valInt",
        },
        {
          text: "Date de saisie",
          label: "Date de saisie",
          value: "date_fiche",
          field: "date_fiche",
          dataFormat: this.epochToTimeStamp,
        },

        {
          text: "Animateur",
          label: "Animateur",
          value: "nom_responsable",
          field: "nom_responsable",
        },
        {
          text: "Région",
          value: "ll_region",
          label: "Région",
          field: "ll_region",
        },
        {
          text: "District",
          value: "ll_district",
          label: "District",
          field: "ll_district",
        },
        {
          text: "Commune",
          value: "ll_commune",
          label: "Commune",
          field: "ll_commune",
        },
        {
          text: "Fokontany",
          value: "ll_fokontany",
          label: "Fokontany",
          field: "ll_fokontany",
        },
        {
          text: "Village",
          value: "village",
          label: "Village",
          field: "village",
        },
      ],
    };
  },
  created() {
    this.getEtape(this.$route.query.etape_id_etape);
  },
  computed: {
    calcul: function () {
      /* Nombre
       var result = 0;
       for (var i = 0; i < $scope.traveler.length; i++) {
              total = total + $scope.traveler[i].Amount;
            } */
      if (this.$route.query.type_champ == 1) {
        return _.sumBy(this.fiches, function (o) {
          return o.valInt;
        });
      } else if (this.$route.query.type_champ == 2) {
        return 0;
      }
    },
  },
  methods: {
    getSexe(sexe) {
      if (sexe == "1") {
        return "Masculin";
      } else {
        return "Féminin";
      }
    },
    epochToTimeStamp(date) {
      return this.$moment(date).format("MM-YYYY");
    },
    getEtape(etapeId) {
      let self = this;
      var docRef = this.$firebase.firestore().collection("etapes").doc(etapeId);
      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            self.etape = doc.data();

            var docRef2 = self.$firebase
              .firestore()
              .collection("activites")
              .doc(self.etape.parcours_id_parcours);

            docRef2
              .get()
              .then((doc) => {
                if (doc.exists) {
                  self.activite = doc.data();
                } else {
                  // doc.data() will be undefined in this case
                  console.log("No such document!");
                }
              })
              .catch((error) => {
                console.log("Error getting document:", error);
              });
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });
    },
    getEtapesEffectives() {
      let self = this;
      self.etapesEffectives = [];
      self.loadingMembre = true;
      console.log("details_etapes_id_details_etape", self.$route.query.id);
      console.log("etape_id_etape", self.$route.query.etape_id_etape);
      /*      this.$firebase
        .firestore()
        .collection("fiches")
        .where("details_etapes_id_details_etape", "==", self.$route.query.id)
        .get()
        .then(
          (snapshot) => {
            snapshot.forEach(function (doc) {
              self.etapesEffectives.push({
                  ...doc.data(),
                  id: doc.id,
                  
                });
            });

            self.loadingMembre = false;
          },
          (error) => {
            console.log(error);
          }
        ); */
      self.loadingMembre = false;
    },
    getFichesCorrespondantes() {
      let self = this;
      self.fiches = [];
      self.loadingMembre = true;
      this.$firebase
        .firestore()
        .collection("fiches")
        .where("details_etapes_id_details_etape", "==", self.$route.query.id)
        .get()
        .then(
          (snapshot) => {
            snapshot.forEach(function (doc) {
              if (self.$route.query.type_champ == 1) {
                self.fiches.push({
                  ...doc.data(),
                  id: doc.id,
                  valInt: Number(doc.data().valeur),
                });
              } else if (self.$route.query.type_champ == 0) {
                if (doc.data().valeur) {
                  //console.log("valeur : ",doc.data().valeur)
                  self.fiches.push({
                    ...doc.data(),
                    id: doc.id,
                    valInt: doc.data().valeur,
                  });
                }
              } else {
                self.fiches.push({
                  ...doc.data(),
                  id: doc.id,
                  valInt: doc.data().valeur,
                });
              }
            });

            self.loadingMembre = false;
          },
          (error) => {
            console.log(error);
          }
        );
    },
  },
};
</script>

<style scoped></style>
